module.exports = __webpack_public_path__ + "@/assets/img/mail-opened.6a9ce0c6.svg";